<template>
    <div>
        <button
            @click="addPOKJA"
            class="px-4 py-2 bg-green-500 text-white rounded mb-5"
        >
            Tambah POKJA
        </button>
        <div
            v-for="(pokja, index) in pokjaList"
            :key="pokja.id || index"
            class="pokja-entry mb-3"
        >
            <div class="lg:w-full md:w-full">
                <div class="flex items-center gap-2">
                    <Dropdown
                        class="w-full"
                        v-model="pokjaList[index].id"
                        :options="filteredPOKJAOptions(pokja.id)"
                        optionLabel="fullname"
                        optionValue="id"
                        filter
                        filterBy="fullname"
                        @filter="fetchPOKJA"
                        @change="validateUniqueness(index)"
                        placeholder="Pilih POKJA Pengadaan"
                    />
                    <button
                        @click="removePOKJA(index)"
                        class="px-4 py-2 bg-red-500 text-white rounded ml-2"
                    >
                        Hapus
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import Dropdown from "primevue/dropdown";
import axios from "axios";

export default defineComponent({
    components: {
        Dropdown,
    },
    props: {
        list_pokja: Array,
        pokja_id : String,
    },
    data() {
        const ttpkInitialList = this.list_ttpk
            ? this.list_ttpk.map((item, idx) => ({
                ...item,
                ttpkUniqueId: item.ttpkUniqueId || this.ttpkGenerateUniqueId(),
                ttpkDisplayIndex: idx + 1
            }))
            : [];
        return {
            pokjaOptions: [],
            ttpkList: ttpkInitialList,
            ttpkNextIndex: (ttpkInitialList.length > 0)
                ? Math.max(...ttpkInitialList.map(item => item.ttpkDisplayIndex || 0)) + 1
                : 1
        };
    },
    watch: {
        list_pokja: {
            handler(ttpkNewValue) {
                if (ttpkNewValue) {
                    // Block recursive updates by checking if the internal change is happening
                    if (this._internalUpdate) return;
                    
                    // Preserve ttpkUniqueIds if present, generate new ones if not
                    this.ttpkList = ttpkNewValue.map((item, idx) => ({
                        ...item,
                        ttpkUniqueId: item.ttpkUniqueId || this.ttpkGenerateUniqueId(),
                        ttpkDisplayIndex: item.ttpkDisplayIndex || (idx + 1)
                    }));
                    
                    // Update ttpkNextIndex based on highest current ttpkDisplayIndex
                    if (this.ttpkList.length > 0) {
                        this.ttpkNextIndex = Math.max(
                            ...this.ttpkList.map(item => item.ttpkDisplayIndex || 0)
                        ) + 1;
                    }
                } else {
                    this.ttpkList = [];
                    this.ttpkNextIndex = 1;
                }
            },
            deep: true,
        },
        pokjaList: {
            handler(ttpkNewValue) {
                // Prevent recursive updates by setting a flag
                this._internalUpdate = true;
                // Emit the updated ttpkList to the parent component
                this.$emit("update:list_ttpk", ttpkNewValue);
                // Reset flag after this update cycle
                this.$nextTick(() => {
                    this._internalUpdate = false;
                });
            },
            deep: true,
        },
    },
    mounted() {
        this.fetchPOKJA({ value: "" });
    },
    methods: {
        ttpkGenerateUniqueId(){
            return Date.now() + '-' + Math.floor(Math.random() * 100);
        },
        addPOKJA() {
            this.ttpkList.push({
                id: null,
                ttpkUniqueId : this.ttpkGenerateUniqueId(),
                ttpkDisplayIndex : this.ttpkNextIndex
            });
            this.ttpkNextIndex++;
        },
        removeTTPK(ttpkIndex) {
            this.ttpkList.splice(ttpkIndex, 1);
        },
        async fetchPOKJA(event) {
            console.log("Keyword : ", event.value);
            try {
                const response = await axios.post(
                    "/organisasi_pengadaan/search_pokja",
                    {
                        params: {
                            keyword: event.value || "",
                            // role: "pokja", // Pass the role as a parameter
                        },
                    }
                );
                if (response.data && Array.isArray(response.data)) {
                    this.pokjaOptions = response.data;
                }
            } catch (error) {
                console.error("Error fetching pokja:", error);
            }
        },
        filteredPOKJAOptions(ttpkCurrentId) {
            // Ensure the currently selected option is available in the dropdown options
            return this.pokjaOptions.concat(
                this.pokjaList.filter(
                    (p) =>
                        p.id === ttpkCurrentId &&
                        !this.pokjaOptions.some(
                            (option) => option.id === ttpkCurrentId
                        )
                )
            );
        },
        validateUniqueness(ttpkCurrentIndex) {
            const ttpkCurrentId = this.pokjaList[ttpkCurrentIndex]?.id;
            if (
                ttpkCurrentId &&
                this.pokjaList.filter(
                    (pokja) => pokja.id === ttpkCurrentId
                ).length > 1
            ) {
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "POKJA duplikat terdeteksi. Pastikan setiap pokja unik.",
                    life: 3000,
                });
                this.pokjaList[ttpkCurrentIndex].id = null;
            }
        },
    },
});
</script>
